import { apiClient } from "../config";

async function getAllBehaviors(queryParams: any) {
  const res = await apiClient.get(`/admin/behaviors`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllBehaviors;
